import { redirect, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/quests/quests-history')({
  beforeLoad: async ({ search, location }) => {
    search.quests = 'quests-history'
    throw redirect({
      to: '/',
      search,
      state: { ...location.state, from: 'deeplink' },
    })
  },
})
